import { ref } from 'vue';
import dayjs from 'dayjs';

const DEFAULT_VISIBLE_ITEMS = 3;

// On load selected date might be more than in 3 months
// so we need to display all months between them
const getInitialVisibleItems = (date: string) => {
  if (date) {
    // We add 2 to load additional 2 months after the selected months
    const monthsDiffWithToday =
      Math.ceil(dayjs(date).diff(dayjs(), 'M', true)) + 2;
    return Math.max(DEFAULT_VISIBLE_ITEMS, monthsDiffWithToday);
  }

  return DEFAULT_VISIBLE_ITEMS;
};

export const useCalendarLazyLoader = (firstSelectedDate: string) => {
  const visibleItems = ref(getInitialVisibleItems(firstSelectedDate));
  const onUpdate = () => (visibleItems.value += 1);

  return {
    visibleItems,
    onUpdate,
  };
};
